import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useCallback } from "react";

import { FillScreen, VStack } from "@/components/Layout";
import { LIST_EMPTY_DATA } from "@/lib/listPage";

import { ShadowItVisitHistoriesFilter as Filter } from "./-components/filter";
import { ShadowItToolbar as Toolbar } from "./-components/shadow-it-toolbar";
import { ShadowItVisitHistoriesTable as Table } from "./-components/table";
import {
  useExportShadowItVisitHistories as useExportCsv,
  useShadowItVisitHistories,
} from "./-query";
import { type SearchParams, SearchSchema } from "./-zod-schema";

export const Route = createFileRoute(
  "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/",
)({
  validateSearch: zodValidator(SearchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const { data, isPending } = useShadowItVisitHistories(search);
  const { mutate: onClickExport, isPending: exporting } = useExportCsv(search);

  const onSearch = useCallback(
    (query: Partial<SearchParams>) => {
      navigate({ search: (prev) => ({ ...prev, ...query }) });
    },
    [navigate],
  );

  const onChangeFilter = useCallback(
    // 検索条件を変更したら1ページ目から検索する
    (query: Partial<SearchParams>) => onSearch({ ...query, pageIndex: 0 }),
    [onSearch],
  );

  return (
    <FillScreen>
      <Toolbar />
      <VStack className="px-12 pt-5 gap-4">
        <Filter
          state={search}
          onChange={onChangeFilter}
          exporting={exporting}
          onClickExport={onClickExport}
        />
        <Table
          data={data ?? LIST_EMPTY_DATA}
          search={search}
          onSearch={onSearch}
          isPending={isPending}
        />
      </VStack>
    </FillScreen>
  );
}
